module.exports = __webpack_public_path__ + "static/media/california_caviar_shrimp.51e877ee.webp";